import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class DataManagerConnectedDatasetsEditRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('ai-chat') declare aiChatService: Service.AIChat;

	override model(params: { space_access_id: string }): string | null {
		const model = params.space_access_id;

		if (!model) {
			this.navigateToAvailable();
		}

		return model;
	}

	// Set here, not in model(): the routes being left deactivate after the new models resolve
	override setupController(controller: Controller, model: string | null): void {
		super.setupController(controller, model);

		this.aiChatService.setSpaceAccessId(model);
	}

	// The side panel outlives the route, so drop the dataset context it was opened with
	override deactivate(): void {
		this.aiChatService.setSpaceAccessId(null);
	}

	private navigateToAvailable(): void {
		this.navigationService.replaceRoute('datamanager.available');
	}
}
